import React, { useEffect } from "react";

import Main from '../components/Fee/Main'
import Stock from "../components/Fee/Stock";
import JoinUs from "../components/Fee/JoinUs";

function Fee () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#F8F8F8]">
            <Main/>
            <Stock/>
            <JoinUs/>
        </div>
    );
}

export default Fee;